import { Pipe, PipeTransform } from '@angular/core';
import { GlobalID } from '../utils/global-id';

@Pipe({ name: 'idFromGid' })
export class IdFromGidPipe implements PipeTransform {
  /**
   * Transforms a GlobalID string by decoding it and returning the numeric ID
   * @param value - The GlobalID string to decode
   * @param options - Optional interface type options for GlobalID.decode
   * @returns The numeric ID extracted from the GlobalID string
   */
  transform(value: string, options?: { interfaceType: string[] }): number | null {
    if (!value) {
      return null;
    }

    try {
      const decoded = GlobalID.decode(value, options);
      return decoded.id;
    } catch (error) {
      console.error('Error decoding GlobalID:', error);
      return null;
    }
  }
}
